import type { DocumentationTabTypes } from '../components/documentation/tabs/types';
import type { DocumentationPageType } from '../components/documentation/types';
import { telemetry } from '../telemetry';

interface StoredTabsByOrg<T> {
  [crmOrgId: string]: T;
}

export const loadTabsForOrg = <T>(storageKey: string, crmOrgId: string): T | null => {
  try {
    const stored = localStorage.getItem(storageKey);
    if (!stored) return null;
    const allOrgs: StoredTabsByOrg<T> = JSON.parse(stored);
    return allOrgs[crmOrgId] ?? null;
  } catch (error) {
    telemetry.captureError(error);
    return null;
  }
};

export const saveTabsForOrg = <T>(storageKey: string, crmOrgId: string, data: T): void => {
  try {
    const stored = localStorage.getItem(storageKey);
    let allOrgs: StoredTabsByOrg<T> = {};

    if (stored) {
      allOrgs = JSON.parse(stored);
    }

    allOrgs[crmOrgId] = data;
    localStorage.setItem(storageKey, JSON.stringify(allOrgs));
  } catch (error) {
    telemetry.captureError(error);
  }
};

// --- Storage keys ---

export const METADATA_TABS_STORAGE_KEY = 'documentation_metadata_tabs';
export const SNOWFLAKE_TABS_STORAGE_KEY = 'snowflake_documentation_tabs';
export const DATA360_TABS_STORAGE_KEY = 'data360_documentation_tabs';
export const HUBSPOT_TABS_STORAGE_KEY = 'hubspot_documentation_tabs';

// --- Salesforce tab helpers ---

export interface StoredMetadataTabsPerOrg {
  [DocumentationPageType.metadataTypes]: DocumentationTabTypes[];
}

export const getUserSelectedTabs = (tabs: DocumentationTabTypes[]) =>
  tabs.filter((tab) => !tab.isNotRemovable);

export const mergeWithDefaultTabs = (
  defaultTabs: DocumentationTabTypes[],
  userTabs: DocumentationTabTypes[],
) => [...defaultTabs, ...userTabs];
